module.exports = __webpack_public_path__ + "eda3530cb962490fecd3bdbeae97c974.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/main/images/ch_grid_11-mobile.png
// module id = 114
// module chunks = 1